var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"56dc370be3637a78ff907d6039ed3f901802260a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["versum-web@versum-studios"]={id:"56dc370be3637a78ff907d6039ed3f901802260a"};
      